import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiGet } from '../lib/api';
import { SkeletonList } from '../components/Skeleton';

interface Customer {
  id: number;
  name: string;
  phone: string | null;
  email: string | null;
  total_visits: number;
  last_visit_at: string | null;
}

export function Customers() {
  const [search, setSearch] = useState('');
  const [items, setItems] = useState<Customer[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    const t = setTimeout(async () => {
      try {
        const q = search.trim() ? `?search=${encodeURIComponent(search.trim())}` : '';
        const r = await apiGet<{ customers: Customer[] }>(`/api/customers${q}`);
        setItems(r.customers);
      } catch (e) {
        setErr((e as Error).message);
      }
    }, 200);
    return () => clearTimeout(t);
  }, [search]);

  return (
    <div className="space-y-3">
      <div className="flex items-baseline justify-between">
        <h1 className="text-xl font-bold">Customers</h1>
        {items && <span className="text-muted text-sm font-mono">{items.length}</span>}
      </div>

      <input
        className="input"
        placeholder="Search name, phone, email"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {err && <p className="text-rose-400">{err}</p>}
      {!items ? (
        <SkeletonList count={5} variant="row" />
      ) : items.length === 0 ? (
        <div className="card text-center py-6">
          <p className="text-muted">No customers yet. They'll appear here as you take bookings.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {items.map((c) => (
            <Link key={c.id} to={`/customers/${c.id}`} className="card block hover:border-accent">
              <div className="flex items-center justify-between">
                <div className="min-w-0">
                  <div className="font-semibold truncate">{c.name}</div>
                  <div className="text-sm text-muted truncate font-mono">{c.phone || c.email || '—'}</div>
                </div>
                <div className="text-right shrink-0 ml-3">
                  <div className="text-sm font-mono font-semibold">{c.total_visits}</div>
                  <div className="text-xs text-muted">visit{c.total_visits === 1 ? '' : 's'}</div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
